import createVueComponent from '../createVueComponent';

const ChevronFirst = createVueComponent('ChevronFirstIcon', [
  ['polyline', { points: '17 18 11 12 17 6' }],
  ['path', { d: 'M7 6v12' }],
]);

export default ChevronFirst;
